module.exports = __webpack_public_path__ + "static/img/19034C_1_2_C_20220323_LC.9ee743b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/19034C_1_2_C_20220323_LC.png
// module id = 3K5N
// module chunks = 0